function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "arrow-line_inline_svg__Union_7",
  "data-name": "Union 7",
  transform: "translate(-422.001 -267.991)",
  opacity: 0.187
}, /*#__PURE__*/React.createElement("path", {
  id: "arrow-line_inline_svg__Union_7-2",
  "data-name": "Union 7",
  d: "M206.106 0L218 17.155zm23.786 0L218 17.155zm0 0zM0 0z",
  transform: "translate(422.001 268.491)",
  fill: "rgba(0,0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "arrow-line_inline_svg__Union_7_-_Outline",
  "data-name": "Union 7 - Outline",
  d: "M0-.5h206.1V0l.414-.287L218 16.277 229.482-.285 229.9 0v-.5H436v1H230.154l-11.745 16.94-.409-.285-.411.285L205.844.5H0z",
  transform: "translate(422.001 268.491)",
  fill: "#fdf7ec"
}));

function SvgArrowLineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 436,
    height: 17.94,
    viewBox: "0 0 436 17.94"
  }, props), _ref);
}

export default SvgArrowLineinline;